<template>
    <div v-loading="loading">
        <el-row>
            <slot name="search"></slot>
        </el-row>
        <el-row class="basic-margin" style="margin-right:20pt;">
            <el-table :data="datas" :span="24" border>
                <div style="background-color: #eee;width: 100%;height: 100%;text-align: center;padding: 65px;"
                     v-if="datas.length==0 || loading">
                    {{loading?'加载中...':'暂时没有数据哦！'}}
                </div>
                <slot name="item" v-else>

                </slot>
            </el-table>
        </el-row>

        <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="[1,10, 20, 50, 100]"
                :total="totalCount"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                class="row basic-margin"
                layout="total, sizes, prev, pager, next, jumper"
                style="margin-left:0px">
        </el-pagination>
    </div>
</template>
<style scpoed>
    .top-margin {
        margin-left: 5px
    }
</style>

<script>
import Config from '../framework/configs/Config'
import BasicModel from '../framework/basic/BasicModel'
import BasicPager from '../mixins/BasicPager'

export default {
  name: 'table-template',
  extends: BasicPager,
  data: function () {
    return {
      loading: false,
      datas: [],
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0, // 总条数
      dialogVisible: false
    }
  },
  props: {
    actionUrl: {
      type: String,
      default: function () {
        return null
      }
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    // 监听页数变化
    handleSizeChange (val) {
      this.pageSize = val
      this.loadList()
    },
    // 监听页码变化
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadList()
    },

    search: function () {
      this.currentPage = 1
      this.loadList()
    },
    loadList: function () {
      let _this = this
      _this.loading = true
      _this.datas = []
      let loginInfo = _this.loginInfo
      let params = this.queryParams
      // 兼容老版本 定义的当前页属性 currentPage
      params.currentPage = _this.currentPage
      params.pageSize = _this.pageSize
      params.pageNum = _this.currentPage
      params.createType = loginInfo.loginPath === 'cxh' ? 1 : 2
      if (loginInfo.loginPath === 'channel') {
        params.channelId = loginInfo.loginPath === 'channel' ? loginInfo.id : null
      }
      let listener = {
        success: function (dataInfo) {
          // 当前组件 调用父组件函数 此时onDataFilter 为父组件声明的数据清洗函数
          _this.$emit('onDataFilter', dataInfo)

          for (var i = 0, temp = dataInfo.data.length; i < temp; i++) {
            let item = dataInfo.data[i]
            if (!item.coverImgURL) {
              item.coverImgURL = Config.imageUrl + dataInfo.data[i].coverImgURL
            }
          }
          _this.datas = dataInfo.data
          _this.totalCount = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      BasicModel.get(this, this.actionUrl, params, listener)
    }
  }
}
</script>
